/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Color_LabelInputs */

const en_speaker_manager_color_label = /** @type {(inputs: Speaker_Manager_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color`)
};

const fr_speaker_manager_color_label = /** @type {(inputs: Speaker_Manager_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur`)
};

const de_speaker_manager_color_label = /** @type {(inputs: Speaker_Manager_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbe`)
};

const it_speaker_manager_color_label = /** @type {(inputs: Speaker_Manager_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore`)
};

const ru_speaker_manager_color_label = /** @type {(inputs: Speaker_Manager_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цвет`)
};

const es_speaker_manager_color_label = /** @type {(inputs: Speaker_Manager_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color`)
};

const zh_cn2_speaker_manager_color_label = /** @type {(inputs: Speaker_Manager_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`颜色`)
};

const ja_speaker_manager_color_label = /** @type {(inputs: Speaker_Manager_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`色`)
};

const hi_speaker_manager_color_label = /** @type {(inputs: Speaker_Manager_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रंग`)
};

const pt_pt2_speaker_manager_color_label = /** @type {(inputs: Speaker_Manager_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor`)
};

/**
* | output |
* | --- |
* | "Color" |
*
* @param {Speaker_Manager_Color_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_color_label = /** @type {((inputs?: Speaker_Manager_Color_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Color_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_color_label(inputs)
	if (locale === "de") return de_speaker_manager_color_label(inputs)
	if (locale === "it") return it_speaker_manager_color_label(inputs)
	if (locale === "ru") return ru_speaker_manager_color_label(inputs)
	if (locale === "es") return es_speaker_manager_color_label(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_color_label(inputs)
	if (locale === "ja") return ja_speaker_manager_color_label(inputs)
	if (locale === "hi") return hi_speaker_manager_color_label(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_color_label(inputs)
	return en_speaker_manager_color_label(inputs)
});